import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withNamespaces } from 'react-i18next'
import i18next from 'i18next'
import HRRequestListItems from './HRRequestListItems'
import * as HRRequestType from '@scripts/HRRequestType';
import * as HRRequestStatusCode from '@scripts/HRRequestStatusCode';
import * as pageSourceCode from '@scripts/PageSourceCode'
import HRRequestDetail from './HRRequestDetail';
import HRRequestTypeCard from './HRRequestTypeCard';
import { isIOS } from '@utils'
import Slide from '@material-ui/core/Slide'
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownToSquare, faAddressCard } from '@fortawesome/pro-duotone-svg-icons';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        maxWidth: '600px',
        backgroundColor: theme.palette.background.paper,
        padding: '10px',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    addIconsContainer: {
        paddingLeft: '10px',
        paddingRight: '10px'
    },
    titleRequestTypes: {
        color: 'var(--color1)',
        display: 'flex',
        width: '100%',
        marginBottom: '10px',
        fontWeight: 'bold'
    },
    titleHistory: {
        color: 'var(--color1)',
        display: 'flex',
        width: '100%',
        fontWeight: 'bold',
        marginTop: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingBottom: '10px'
    },
    titlePending: {
        color: 'var(--color1)',
        display: 'flex',
        width: '100%',
        fontWeight: 'bold',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingBottom: '10px'
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function HrRequestHome() {
    const classes = useStyles();

    const [isiOS, setIsiOS] = React.useState(isIOS());
    const [open, setOpen] = React.useState(false);
    const [isReload, setIsReload] = React.useState(false);
    const [dataRow, setDataRow] = React.useState(null);

    const filterRecentHistory = {
        requestType: [HRRequestType.Type_DocumentDeposit],
        status: Object.values(HRRequestStatusCode)
    }

    const filterProcessingRequest = {
        requestType: [HRRequestType.Type_DocumentDeposit],
        status: [HRRequestStatusCode.Waiting, HRRequestStatusCode.NewRequest]
    }

    const emptyRequest = {
        hrRequestTypeId: '',
        hrRequest: {
            hrRequestId: 0
        }
    };

    useEffect(() => {
        resizePage();
    }, []);

    const triggerReload = () => {
        setIsReload(prev => !prev);
    };

    const handleNewRequest = (requestType) => {
        setDataRow({
            hrRequestTypeId: requestType,
            hrRequest: {
                hrRequestId: 0
        }
    });

    setOpen(true);
    }

    const resizePage = () => {
        const height = window.innerHeight;
        const titleBar = document.querySelector('#appBarTitle').clientHeight;
        const header = document.querySelector('div[data-id=headerHRRequest]').offsetHeight;
        const element = document.querySelector('#divHRRequestHome');
        const offSet = 30;

        const customHeight = height - header - titleBar - offSet;

        if (element !== null) {
            element.style.height = `${customHeight}px`;
            element.style.overflowX = 'hidden';
        }
    }

    const handleCloseClick = () => {
        setOpen(false);
        setIsReload(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <div id="divHRRequestHome" className={classes.root}>

                {/* REQUEST TYPES */}
                <div className={classes.addIconsContainer}>
                    <span className={classes.titleRequestTypes}>
                        {i18next.t('hrRequest:title.requestTypes')}
                    </span>
                    
                    <HRRequestTypeCard
                        icon={ <FontAwesomeIcon icon={faArrowDownToSquare} style={{ fontSize: '25px', color: 'var(--color1)' }} /> }
                        title={i18next.t('hrRequest:requestType.documentDeposit')}
                        description={i18next.t('hrRequest:addIconDescription.documentDeposit')}
                        onClick={() => handleNewRequest(HRRequestType.Type_DocumentDeposit)}
                    />

                    <HRRequestTypeCard
                        disabled
                        icon={<FontAwesomeIcon icon={faAddressCard} style={{ fontSize: '25px', color: 'var(--color1)' }} />}
                        title={i18next.t('hrRequest:requestType.changeInformation')}
                        description={i18next.t('hrRequest:addIconDescription.comingSoon')}
                    />

                    <HRRequestTypeCard
                        disabled
                        icon={<AddIcon style={{ fontSize: '25px', color: 'var(--color1)' }} />}
                        title={i18next.t('hrRequest:requestType.otherRequest')}
                        description={i18next.t('hrRequest:addIconDescription.comingSoon')}
                    />
                </div>

                <div>
                    {/* Pending */}

                    <span className={classes.titlePending}>
                        {i18next.t('hrRequest:title.pending')}
                    </span>
                    <HRRequestListItems
                        isReload={isReload}
                        filter={filterProcessingRequest}
                        pageSource={pageSourceCode.PageSource_HRRequestPendingRequests}
                        type={pageSourceCode.PageSource_HRRequestPendingRequests}
                        isHomePage={true}
                    />

                    {/* Recent History */}
                    <span className={classes.titleHistory}>
                        {i18next.t('hrRequest:title.recentHistory')}
                    </span>
                    <HRRequestListItems
                        isReload={isReload}
                        filter={filterRecentHistory}
                        pageSource={pageSourceCode.PageSource_HRRequestHome}
                        type={pageSourceCode.PageSource_HRRequestRecentHistory}
                        isHomePage={true}
                    />
                </div>
                <HRRequestDetail open={open} onClose={handleCloseClick} data={dataRow || emptyRequest} onReload={triggerReload} />
            </div>
        </>
    );
}

export default withNamespaces(['hrRequest'], { wait: true })(HrRequestHome);